import { render, staticRenderFns } from "./PricesFormComponent.vue?vue&type=template&id=f8cf8230&xmlns=true&"
import script from "./PricesFormComponent.vue?vue&type=script&lang=js&"
export * from "./PricesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports